import { HiMenuAlt2, HiSortAscending, HiSortDescending } from 'react-icons/hi';
import { head, orderBy } from 'lodash-es';
import { UserRole } from '@/api/apis/user';
import { AssignedUser, OrganType } from '@/api/apis/case';
import { GroupWeightType, NameByValue, OrganAcceptanceCriteriaWeightType, RolesWeightType } from '@/types';

export const getSortIcon = (isAsc?: boolean) => {
  switch (isAsc) {
    case true:
      return <HiSortAscending size={20} />;
    case false:
      return <HiSortDescending size={20} />;
    default:
      return <HiMenuAlt2 size={20} />;
  }
};

export const getLatest = <T extends { timestamp: string }>(data: T[]): T | undefined => {
  const sortedData: T[] = orderBy(data, ['timestamp'], ['desc']);
  return head(sortedData);
};

export const sortUsersByRole = (users: AssignedUser[], rolesWeight: RolesWeightType): AssignedUser[] => {
  const roles = Object.keys(rolesWeight) as UserRole[];
  return users.toSorted((a, b) => {
    const roleA = roles.find((role) => a.user.roles.find((r) => role === r)) || a.user.roles[0];
    const roleB = roles.find((role) => b.user.roles.find((r) => role === r)) || b.user.roles[0];
    const weightA = rolesWeight[roleA] || 0;
    const weightB = rolesWeight[roleB] || 0;

    return (weightA || 0) - (weightB || 0);
  });
};

export const sortUsersByGroup = (
  users: AssignedUser[],
  groupsWeight: GroupWeightType,
  selectPrimary: boolean = false,
) => {
  return users.toSorted((a, b) => {
    const isPrimaryA = a.isPrimary ? 1 : 2;
    const isPrimaryB = b.isPrimary ? 1 : 2;

    const groupA = groupsWeight[a.group] || 0;
    const groupB = groupsWeight[b.group] || 0;

    if (!selectPrimary || isPrimaryA === isPrimaryB) {
      return (groupA || 0) - (groupB || 0);
    }

    return isPrimaryA - isPrimaryB;
  });
};

export const sortTemplateDonorTypes = (
  donorTypes: NameByValue<OrganType, string>[],
  acceptanceCriteriaWeight: OrganAcceptanceCriteriaWeightType,
): NameByValue<OrganType, string>[] => {
  return donorTypes.toSorted((a, b) => {
    const weightA = acceptanceCriteriaWeight[a.value] || 0;
    const weightB = acceptanceCriteriaWeight[b.value] || 0;
    return weightA - weightB;
  });
};
